import { DigitPurpose, DigitLimits as Limits } from "@sablier/v2-constants";
import { BigNumber } from "@sablier/v2-mixins";

export type Definition = { d: string; p: DigitPurpose }[];

export type Context = {
  computed: {
    characteristic: BigNumber;
    characteristicDigits: string[];
    characteristicPrecision: number;
    definition: Definition;
    mantissa: BigNumber;
    mantissaDigits: string[];
    mantissaPrecision: number;
    mantissaSuffix: boolean;
    sanitized: string;
  };
  source: string;
};

export const Initial: Context = {
  computed: {
    characteristic: new BigNumber(0),
    characteristicDigits: [],
    characteristicPrecision: Limits.STATIC_PRECISION[0],
    definition: [],
    mantissa: new BigNumber(0),
    mantissaDigits: [],
    mantissaPrecision: Limits.STATIC_PRECISION[0],
    mantissaSuffix: true,
    sanitized: "0",
  },
  source: "0",
};

export { Limits };
